import { onBreakpoint } from 'svelte-stylo';

export function updateContainer(container, field, value, auto) {
  if (auto === "auto")
    container.layout = autoLayout(value, field.maxch, field.type, container.layout);
  
  container.required =  field.required && !field.disabled && !field.readonly;

  const status = (container.errors || []).length ? 'error' : container.status;
  container.status = (value || '').trim().length ? status : 'empty';

  return container;
}

function autoLayout(value, maxch, type, layout) {
  if (type==='area') return 'stacked';
  let isPhone = onBreakpoint({'*': true, 'md': false})
  return (isPhone && layout==='inline' && value!==null && value.length > maxch) 
          ? 'stacked' 
          : layout;
}
